<template>
  <v-form>
    <v-row dense>
      <v-col cols="3">
        <v-autocomplete
          dense
          outlined
          placeholder=" "
          v-model="record.CardCode"
          :items="customers"
          label="Customer"
          item-text="Name"
          item-value="id"
        ></v-autocomplete>
      </v-col>

      <v-col cols="3">
        <v-text-field outlined dense label="Amount Paid" v-model="record.SumApplied"></v-text-field>
      </v-col>

      <v-col cols="3">
        <v-autocomplete
          dense
          outlined
          placeholder=""
          v-model="record.o_a_c_t_s_id"
          :items="accounts"
          label="Payment Mode"
          item-text="Name"
          item-value="id"
        ></v-autocomplete>
      </v-col>

      <v-col cols="3">
        <DatePicker @date="setDate" :myDate="date" :title="`Date`"></DatePicker>
      </v-col>

      <v-col cols="12">
        <v-btn v-if="docCreate == true" color="accent" @click="sendData" :loading="loader">
          <v-icon left>mdi-content-save</v-icon>Save
        </v-btn>

        <v-btn v-else color="accent" @click="sendData" :loading="loader">
          <v-icon left>mdi-content-save</v-icon>Update
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>


<script>
export default {
  name: "SuppliersIndex",
  props: {
    initial: {
      type: Object,
      required: true,
    },
    docCreate: {
      type: Boolean,
    },
  },
  data: () => ({
    record: {},
    customers: [],
    accounts: [],
    loader: false,
    date: new Date().toISOString().substr(0, 10),
  }),
  watch: {
    initial: {
      handler: "init",
      immediate: true,
    },
  },
  methods: {
    init(val) {
      this.record = { ...val };
    },
    setDate(date) {
      this.record.date = date;
    },
    sendData() {
      this.loader = true;
      this.$emit("data", this.record);
    },
    getCustomers() {
      const self = this;
      this.$store
        .dispatch("get", `/customers`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.customers = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getAccounts() {
      const self = this;
      this.$store
        .dispatch("get", `/accounts`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.accounts = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getCustomers();
    this.getAccounts();
  },
};
</script>